(function () {
  "use strict";

  brandSettings.$inject = ['$timeout'];
  angular
    .module('branding')
    .directive('brandSettings', brandSettings);

  function brandSettings($timeout) {
    return {
      restrict: 'A',
      templateUrl: 'pages/branding/template/settings.html',
      transclude: true,
      replace: true,
      require: '^brandCrud',
      scope: {
        cancel: '&',
        save: '&'
      },
      link: function (scope, element, attrs, ctrl) {

        scope.doCancel = function () {
          ctrl.setDirty(false);
          ctrl.resetting = true;
          scope.cancel();
          $timeout(function () {
            ctrl.resetting = false;
          }, 0, false);
        };

        scope.doSave = function () {
          ctrl.resetting = true;
          ctrl.setDirty(false);
          ctrl.saveLogo(logoSaved);
        };

        function logoSaved() {
          scope.save().then(function () {
            $timeout(function () {
              ctrl.resetting = false;
              ctrl.setDirty(false);
            }, 0, false);
          });
        }
      }
    };
  }

})();
